import React, { useEffect, useMemo } from 'react';
import { Timeline, Spin, Flex } from 'antd';
import { mdiDatabaseOff } from '@mdi/js';
import { Icon } from '@mdi/react';
import { useUserJourneyMutation } from 'modules/ReportModule/api/report.api';
import useQueryParams from 'hooks/useQueryParams';
import Ninja from '@ninja';
import { LoadingOutlined } from '@ant-design/icons';
import EventTimelineItem from './EventTimelineItem';
import SessionTimelineItem from './SessionTimelineItem';
import getDefaultFilters from 'modules/ReportModule/drawers/components/DefaultFilters';

const UserJourney = ({ trigger }) => {
  const { searchParams } = useQueryParams();
  const [fetchUserJourneyQuery, { isFetching, isLoading, data = {}, reset }] =
    useUserJourneyMutation();

  const defaultFilters = useMemo(() => getDefaultFilters(searchParams), [searchParams]);

  const runQuery = (params) => {
    fetchUserJourneyQuery(params || {}).unwrap();
  };

  useEffect(() => {
    runQuery(defaultFilters);
  }, [searchParams]);

  const items = [];

  data?.sessions?.forEach((session) => {
    session.events?.forEach((event) => {
      items.push(EventTimelineItem({ event, url: session?.url, trigger: trigger, session }));
    });
    items.push(SessionTimelineItem({ session, trigger: trigger }));
  });

  if (isFetching || isLoading) {
    return (
      <Spin
        indicator={<LoadingOutlined spin />}
        size='large'
        className='flex justify-center mt-5'
      />
    );
  }

  if (items.length === 0) {
    return (
      <Flex
        gap='small'
        align='center'
        justify='center'
        vertical
        className='mt-5 text-sm font-normal color-light text-dark-text'
      >
        <Icon path={mdiDatabaseOff} color={Ninja.colors.gray} className='m-auto' />
        No data found
      </Flex>
    );
  }

  return (
    <div className='mx-2 mt-4 sm:ml-4 journey-timeline'>
      <Timeline items={items} mode='left' className='' />
    </div>
  );
};

UserJourney.propTypes = {};

export default UserJourney;
